import _ from 'lodash'

export function request (params) {
  let data = [
    {
      name: 'John Briner',
      firm: 'John D. Briner Law Corporation',
      legalOrder: 'SEC Litigation Release No. 21193 / September 1, 2009',
      location: 'Vancouver, BC',
      date: 'March 15, 2006'
    },
    {
      name: 'John Briner',
      firm: 'John D. Briner Law Corporation',
      legalOrder: 'SEC Litigation Release No. 21193 / September 1, 2009',
      location: 'Vancouver, BC',
      date: 'March 15, 2006'
    },
    {
      name: 'John Briner',
      firm: 'John D. Briner Law Corporation',
      legalOrder: 'SEC Litigation Release No. 21193 / September 1, 2009',
      location: 'Vancouver, BC',
      date: 'March 15, 2006'
    },
    {
      name: 'John Briner',
      firm: 'John D. Briner Law Corporation',
      legalOrder: 'SEC Litigation Release No. 21193 / September 1, 2009',
      location: 'Vancouver, BC',
      date: 'March 15, 2006'
    }
  ]

  const length = data.length

  // Sort On
  if (params.sortOn) {
    data = _.orderBy(data, params.sortOn, params.sortDir || 'desc')
  }

  // Handle Page
  let page = 1
  if (params.page) page = params.page
  // Page Size
  if (params.pageSize) {
    data = data.slice(page === 1 ? 0 : (page - 1) * params.pageSize,
      page === 1 ? params.pageSize : ((page - 1) * params.pageSize) + params.pageSize)
  }

  return {
    totalRecords: length,
    pages: Math.ceil(length / params.pageSize),
    pageSize: params.pageSize,
    records: data,
    sortOn: params.sortOn,
    isRealTime: false,
    bySymbol: true
  }
}
